import type { WorkMode } from '@heidi/agents/contracts';
import { atom } from 'jotai';

/** Null until a composer hydrates or the clinician picks a mode. */
export const workComposerModeAtom = atom<WorkMode | null>(null);

/** The session whose side panel holds a just-started Evidence chat. */
export const openEvidenceChatSessionIdAtom = atom<string | null>(null);

/**
 * Clinical session that forced an unsaved Evidence divert. Cleared when another
 * session's pane mounts so its composer hydrates from the saved work-home mode.
 */
export const evidenceDivertOriginSessionIdAtom = atom<string | null>(null);

/** True while the mode came from an app action, not a pick: composers skip saving it. */
export const isWorkComposerModeUnsavedAtom = atom(false);

export const setWorkComposerModeAtom = atom(
  null,
  (_get, set, next: WorkMode | null, unsaved: boolean) => {
    set(workComposerModeAtom, next);
    set(isWorkComposerModeUnsavedAtom, unsaved);
  }
);
